import React from "react";
import uklogo from "../../assets/kangaroo/uk_logo-cropped.svg";
import { Col, Row } from "reactstrap";
import button from "../../assets/kangaroo/logobtn.svg";
import { useNavigate } from "react-router-dom";
import { ArrowButton } from "../../component/button/ArrowButton";

const Kcomponent = ({ isMobile, setHoveredLetter, data }) => {
  const router = useNavigate();
  return (
    <>
      {!isMobile ? (
       <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 777.31 398.17"

  >
    <defs>
      <style>
        {
          "\n      .cls-1 {\n        font-family: Proxima Nova Regular, 'Proxima Nova';\n        font-size: 22px;\n      }\n\n      .cls-2 {\n        font-family: Proxima Nova Bold, 'Proxima Nova';\n        font-size: 18.83px;\n        font-weight: 700;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #890194;\n      }\n\n      .cls-4 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-5 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        opacity: .84;\n      }\n\n      .cls-8 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-9 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-3 {\n        font-family: ProximaNova-Black, 'Proxima Nova';\n        font-size: 52px;\n        font-weight: 800;\n      }\n\n      .cls-10 {\n        stroke-width: 1.58px;\n      }\n\n      .cls-10, .cls-11 {\n        stroke-linejoin: round;\n      }\n\n      .cls-10, .cls-11, .cls-12 {\n        fill: none;\n        stroke-linecap: round;\n      }\n\n      .cls-10, .cls-12 {\n        stroke: #000;\n      }\n\n      .cls-13 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-14 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-11 {\n        stroke: #890194;\n        stroke-width: 1.5px;\n      }\n\n      .cls-12 {\n        stroke-miterlimit: 10;\n        stroke-width: 1.53px;\n      }\n\n      .cls-15 {\n        opacity: .5;\n      }\n    "
        }
      </style>
    </defs>
    <g onMouseEnter={() => setHoveredLetter("K")}
  onMouseLeave={() => setHoveredLetter(null)}>
        <rect
    x="320"
    y="80"
    width="550"
    height="330"
    stroke="none"
    fill="transparent"
    strokeWidth="1"
      pointerEvents="all"
  />
    <foreignObject
  x="327.86"
  y="80"
  width="450"
  height="200"
>
  <div
    xmlns="http://www.w3.org/1999/xhtml"
    style={{
      fontFamily: "Proxima Nova",
      fontSize: "52px",
      fontWeight: 800,
      color: data?.[0]?.titleColor,
      lineHeight: "1.1",
      wordWrap: "break-word",
    }}
  >
    {data?.[0]?.title}
  </div>
</foreignObject>
   <foreignObject
  x="327.86"
  y="260"
  width="360"
  height="120"
>
  <div
    xmlns="http://www.w3.org/1999/xhtml"
    style={{
      fontFamily: "Proxima Nova Regular",
      fontSize: "22px",
      color: "black",
      lineHeight: "1.1",
      wordWrap: "break-word",
    }}
  >
    {data?.[0]?.subTitle}
  </div>
</foreignObject>

    <g onClick={()=>router(data?.[0]?.buttonUrl)}>
      <text style={{fontFamily:"Proxima Nova Bold", fontSize:"19px", fill:data?.[0]?.buttonColor, cursor:"pointer"}} transform="translate(400.38 370.75)">
        <tspan x={0} y={0}>
          {data?.[0]?.buttonText}
        </tspan>
      </text>
      <path
      style={{cursor:"pointer",}}
       pointerEvents="all"
      
        className="cls-11"
        d="M568.16,328.96h-206.29c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33c-1.49-1.49-1.49-3.9,0-5.39,1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c.77.77,1.13,1.78,1.11,2.79.02,1.01-.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33h-42.49c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23h0c0-18.9-15.32-34.23-34.23-34.23Z"
      />
      </g>
    </g>
  

  </svg>
      ) : (
         <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 662.01 173.55"
    >
       
       
      {/* Headline */}
      <text
        transform="translate(0 31.67)"
        style={{
          fontFamily: "Proxima Nova Black",
          fontSize: "38px",
          fontWeight: 800,
          fill: "#890194",
        }}
      >
        <tspan x="0" y="0">KICK</tspan>
        <tspan x="89.26" y="0" style={{ letterSpacing: "-0.02em" }}>S</tspan>
        <tspan x="111.79" y="0" style={{ letterSpacing: "-0.06em" }}>T</tspan>
        <tspan x="132.12" y="0">A</tspan>
        <tspan x="159.1" y="0">R</tspan>
        <tspan x="184.49" y="0">T </tspan>
        <tspan x="216.79" y="0" style={{ letterSpacing: "-0.04em" }}>Y</tspan>
        <tspan x="240.5" y="0">OUR</tspan>

        <tspan x="0" y="38">UK EDU</tspan>
        <tspan x="144.09" y="38">C</tspan>
        <tspan x="170.2" y="38" style={{ letterSpacing: "-0.06em" }}>A</tspan>
        <tspan x="194.9" y="38">TION </tspan>

        <tspan x="0" y="76">JOURNEY</tspan>
      </text>

      {/* Description */}
      <text
        transform="translate(0 140.61)"
        style={{
          fontFamily: "Proxima Nova Regular",
          fontSize: "20px",
          fill: "#000",
        }}
      >
        <tspan x="0" y="0">
          Discover world-class universities and
        </tspan>
        <tspan x="0" y="24">
          career-focused programs in the UK.
        </tspan>
      </text>

      {/* Button */}
      <g onClick={()=>router(data?.[0]?.buttonUrl)}>
        <text
          transform="translate(459.25 94.94)"
          style={{
            fontFamily: "Proxima Nova Bold",
            fontSize: "18.83px",
            fontWeight: 700,
            fill: "#890194",
          }}
        >
          <tspan x="0" y="0">KN</tspan>
          <tspan x="25.7" y="0" style={{ letterSpacing: "-0.02em" }}>O</tspan>
          <tspan x="39.72" y="0">W MORE</tspan>
        </text>

        <path
          d="M627.03,53.15h-206.29c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33c-1.49-1.49-1.49-3.9,0-5.39,1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c.77.77,1.13,1.78,1.11,2.79.02,1.01-.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33h-42.49c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23s-15.32-34.23-34.23-34.23Z"
          style={{
            fill: "none",
            stroke: "#890194",
            strokeWidth: "1.5px",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </g>
    </svg>
      )}
    </>
  );
};

export default Kcomponent;
